import React, {useEffect, useRef} from 'react';
import styled from "styled-components";
import {getFirstField, isExcluded} from "../commonmethod/CommonMethod";

const Container = styled.div`
    color: black;
    height: 35px;
    line-height: 35px;
    padding: 0 1rem;
    font-weight: bold;
    background-color: ${(props) =>
            props.isdragging
                    ? "#464643"
                    : ""};
    color: ${(props) =>
            props.isdragging
                    ? "#ffffff"
                    : ""};
`;

const InitButton = styled.button`
    color: black;
    height: 35px;
    line-height: 35px;
    padding: 0 1rem;
    font-weight: bold;
`;
function HeaderModifier({header, exArray, setExArray, setFilterOpen, setPinned}) {
    const wrapperRef = useRef(null);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setFilterOpen(false);
        }
    };

    const handleCheckToggle = (field) => {
        if (isExcluded(field, exArray)) {
            setExArray(exArray.filter(each => getFirstField(each) !== getFirstField(field)));
        } else {
            setExArray([...exArray, field]);
        }

        setPinned(false);
    }

    return (
        <div className={"th-filter " } ref={wrapperRef}>
            <div className="p-2">
                { header?.map((item, index) => (
                    <div className={`text-left mb-1 hover:bg-red-50`}>
                        <label className="checkbox-jelly">
                            <input
                                type={"checkbox"}
                                checked={!isExcluded(item.field, exArray)
                                    // !exArray.includes(item.field)
                            }
                                onChange={()=>handleCheckToggle(item.field)}
                            />
                            <span className={"icon"}></span>
                            <span className={`ml-3`} >
                                {header[index].name}
                            </span>
                        </label>

                    </div>
                ))}
            </div>
        </div>
    );
}

export default HeaderModifier;